import { render, staticRenderFns } from "./ElContactForm.vue?vue&type=template&id=86e1b93c&scoped=true&"
import script from "./ElContactForm.vue?vue&type=script&lang=js&"
export * from "./ElContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e1b93c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86e1b93c')) {
      api.createRecord('86e1b93c', component.options)
    } else {
      api.reload('86e1b93c', component.options)
    }
    module.hot.accept("./ElContactForm.vue?vue&type=template&id=86e1b93c&scoped=true&", function () {
      api.rerender('86e1b93c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/ElContactForm.vue"
export default component.exports